import { render, staticRenderFns } from "./segmentationFixHandler.vue?vue&type=template&id=09e110ef&scoped=true"
import script from "./segmentationFixHandler.vue?vue&type=script&lang=js"
export * from "./segmentationFixHandler.vue?vue&type=script&lang=js"
import style0 from "./segmentationFixHandler.vue?vue&type=style&index=0&id=09e110ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e110ef",
  null
  
)

export default component.exports